import React from 'react';
import ErrorHandler from '../class/ErrorHandler';
import * as requestLib from '../lib/requestLib';
import Skeleton from '../components/skeleton/Setting';
import ArrowIcon from '../assets/img/setting/arrow.js';
import '../assets/css/setting.scss';
import SettingItem from '../components/setting/item';
import Refresh from '../components/Refresh';
import { connect } from 'react-redux';
import $ from 'jquery';

class Setting extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      active: null,
      refresh: false
    };
    this.errorHandler = new ErrorHandler(this);
    this.baseUrl = requestLib.getUrl();
  }

  componentDidMount() {
    setTimeout(
      function () {
        this.setState({ loading: false });
      }.bind(this),
      800
    );
    $(window).scroll(function () {
      $('#setting .left').css('top', +$(window).scrollTop());
    });
  }

  componentDidUpdate() {
    if (this.props.isRefresh && !this.state.refresh) {
      this.setState({ refresh: true });
      if (this.state.active !== 'shareUser') {
        setTimeout(
          function () {
            this.setState({ refresh: false });
            this.props.setIsRefresh(false);
          }.bind(this),
          500
        );
      }
    } else if (!this.props.isRefresh && this.state.refresh) {
      this.setState({ refresh: false });
    }
  }

  render() {
    try {
      return (
        <div id="setting" className="page">
          {this.state.loading ? (
            <Skeleton />
          ) : (
            <div className="wrap">
              <div className="left">
                <ul className="setting-box">
                  <li
                    onClick={() =>
                      this.state.active === 'refresh' || !this.state.active
                        ? this.setState({ active: 'user' })
                        : this.setState({ active: null })
                    }
                  >
                    <span>사용자 및 장소 정보</span>
                    <ArrowIcon
                      transform={
                        this.state.active === 'user' ||
                        this.state.active === 'userInfo' ||
                        this.state.active === 'shareUser'
                          ? true
                          : false
                      }
                    />
                  </li>
                  <div
                    className={
                      this.state.active === 'user' ||
                      this.state.active === 'userInfo' ||
                      this.state.active === 'shareUser'
                        ? 'wrap active'
                        : 'wrap'
                    }
                  >
                    <li
                      onClick={() => this.setState({ active: 'userInfo' })}
                      className={
                        this.state.active === 'userInfo' ? 'sub active' : 'sub'
                      }
                    >
                      <span>사용자</span>
                      <ArrowIcon />
                    </li>
                    <li
                      onClick={() => this.setState({ active: 'shareUser' })}
                      className={
                        this.state.active === 'shareUser' ? 'sub active' : 'sub'
                      }
                    >
                      <span>장소 구성원</span>
                      <ArrowIcon />
                    </li>
                  </div>
                  <li
                    onClick={() => this.setState({ active: 'refresh' })}
                    className={this.state.active === 'refresh' ? 'active' : ''}
                  >
                    <span>대시보드 자동 새로고침</span>
                    <ArrowIcon />
                  </li>
                </ul>
                <ul className="setting-box">
                  <li className="version-info">
                    <span>버전</span>
                    <span>2.6.0</span>
                  </li>
                </ul>
              </div>
              <SettingItem type={this.state.active} />
              {/* 새로고침 */}
              {this.state.refresh && <Refresh />}
            </div>
          )}
        </div>
      );
    } catch (error) {
      this.errorHandler.processError(error);
      return null;
    }
  }
}

function mapStateToProps(state) {
  return {
    accessToken: state.hejhome.accessToken,
    userName: state.hejhome.userName,
    isRefresh: state.hejhome.isRefresh,
    navigationWidth: state.hejhome.navigationWidth
  };
}

// dispatch - set
const mapDispatchToProps = dispatch => ({
  setAccessToken: token =>
    dispatch({
      type: 'setAccessToken',
      accessToken: token
    }),
  setUserName: name =>
    dispatch({
      type: 'setUserName',
      userName: name
    }),
  setIsRefresh: bool =>
    dispatch({
      type: 'setIsRefresh',
      isRefresh: bool
    })
});

Setting = connect(mapStateToProps, mapDispatchToProps)(Setting);

export default Setting;
